/**
 * 주요 시설(primary_pools) 순번으로 시설 목록 정렬.
 * - 순번 지정: order 오름차순으로 앞쪽
 * - 순번 미지정: 지정분 뒤에서 이름(또는 code) 가나다순 (기존 관제 정렬)
 */
export function sortPoolsByPrimaryOrder<T extends { code?: string | null; name?: string | null }>(
  pools: T[],
  primarySlots: Array<{ code: string; order: number }>
): T[] {
  if (!pools.length) return pools;
  const orderByCode = new Map(
    (primarySlots || []).map((s) => [String(s.code || '').toUpperCase(), Number(s.order)])
  );
  return [...pools].sort((a, b) => {
    const ca = String(a.code || '').toUpperCase();
    const cb = String(b.code || '').toUpperCase();
    const oa = orderByCode.get(ca);
    const ob = orderByCode.get(cb);
    const aPrimary = oa != null && Number.isFinite(oa) && oa >= 1;
    const bPrimary = ob != null && Number.isFinite(ob) && ob >= 1;
    if (aPrimary && bPrimary) {
      return (oa as number) - (ob as number) || ca.localeCompare(cb, 'ko');
    }
    if (aPrimary) return -1;
    if (bPrimary) return 1;
    return String(a.name || a.code || '').localeCompare(
      String(b.name || b.code || ''),
      'ko'
    );
  });
}
